import type { SVGProps } from 'react';
import * as React from 'react';

const ExclamationTriangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/exclamation-triangle">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1815 4.05C10.9897 2.65 13.0105 2.65 13.8188 4.05L21.3532 17.1C22.1615 18.5 21.1511 20.25 19.5345 20.25H4.46568C2.8491 20.25 1.83874 18.5 2.64703 17.1L10.1815 4.05ZM12 7.05601C12.4971 7.05601 12.9 7.45895 12.9 7.95601V12.156C12.9 12.6531 12.4971 13.056 12 13.056C11.503 13.056 11.1 12.6531 11.1 12.156V7.95601C11.1 7.45895 11.503 7.05601 12 7.05601ZM12 17.856C12.6628 17.856 13.2 17.3187 13.2 16.656C13.2 15.9933 12.6628 15.456 12 15.456C11.3373 15.456 10.8 15.9933 10.8 16.656C10.8 17.3187 11.3373 17.856 12 17.856Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default ExclamationTriangleIcon;
